// SubscriptionCard.tsx
import React from "react";

export const EmailVerifiedCard: React.FC<{ dateISO: string }> = ({ dateISO }) => (
    <div className="bg-green-50 text-green-700 p-3 rounded-lg text-sm">
        Почта подтверждена {new Date(dateISO).toLocaleDateString()}
    </div>
);

type Props = {
    description: string;   // строчка с описанием плана
    expiresAt: string;     // ISO-дата окончания подписки
};

const splitToItems = (desc: string): string[] => {
    // 1) пробуем по «;» и маркерам списка
    const bySemicolon = desc.split(/[;•·]/).map(s => s.trim()).filter(Boolean);
    if (bySemicolon.length > 1) return bySemicolon;

    // 2) если описание как одна фраза — пробуем « — » и запятые
    const byDash = desc.split(/ — | - /).map(s => s.trim()).filter(Boolean);
    if (byDash.length > 1) return byDash;

    const byComma = desc.split(",").map(s => s.trim()).filter(Boolean);
    if (byComma.length > 1) return byComma;

    // 3) fallback — ничего не делим
    return [desc.trim()];
};

export const SubscriptionCard: React.FC<Props> = ({ description, expiresAt }) => {
    const dateStr = new Date(expiresAt).toLocaleDateString();

    // Определяем тест/оплата по описанию
    const isTrial = /тест|trial/i.test(description);

    // Название плана — первая «съедобная» часть, всё остальное — детали
    // Пример: "Индивидуальная — безлимит объявлений; ранний доступ; ..."
    const parts = description.split(/:|—|-/).map(s => s.trim()).filter(Boolean);
    const planName = parts.length ? parts[0] : "Подписка";
    const detailsRaw = description.replace(planName, "").trim();
    const items = splitToItems(detailsRaw).filter(i => i && i.toLowerCase() !== planName.toLowerCase());

    return (
        <div className="rounded-xl p-4 bg-gray-50">
            <div className="flex items-center justify-between">
                <div className="text-sm text-gray-500">Подписка</div>
                <span className={`text-xs px-2 py-0.5 rounded-full ${isTrial ? "bg-yellow-100 text-yellow-700" : "bg-green-100 text-green-700"}`}>
          {isTrial ? "Тест до" : "Активна до"} {dateStr}
        </span>
            </div>

            <div className="mt-1 text-base font-medium">{planName}</div>

            {items.length > 0 ? (
                <div className="mt-3">
                    <div className="text-sm text-gray-500 mb-1">Что входит:</div>
                    <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
                        {items.map((it, idx) => (
                            <li key={idx}>{it}</li>
                        ))}
                    </ul>
                </div>
            ) : (
                // Если ничего не получилось «разложить» — показываем исходное описание как есть
                <div className="mt-2 text-sm text-gray-700">{description}</div>
            )}
        </div>
    );
};
